
export const SET_DAY = "SET_DAY";
export const SET_APPLICATION_DATA = "SET_APPLICATION_DATA";
export const SET_INTERVIEW = "SET_INTERVIEW";

export default function reducer(state, action) {
  switch (action.type) {
    case SET_DAY: {
      return ({ ...state, day: action.day })
    }
    case SET_APPLICATION_DATA: {
      return ({
        ...state,
        days: action.days,
        appointments: action.appointments,
        interviewers: action.interviewers,
      })
    }
    case SET_INTERVIEW: {
      const appointment = { ...state.appointments[action.id] }
      appointment.interview = action.interview;

      const appointments = {
        ...state.appointments,
        [action.id]: appointment,
      }

      const newState = { ...state, appointments }

      const getDaysWithNewSpots = (state) => {
        return state.days.map(day => {
          const spots = day.appointments.filter(appointment => !state.appointments[appointment].interview).length

          return { ...day, spots };
        })
      }

      const days = getDaysWithNewSpots(newState);

      return ({
        ...state,
        appointments,
        days,
      })
    }

    default: {
      throw new Error(
        `Tried to reduce with unsupported action type: ${action.type}`
      );
    }
  }
}